import React from 'react';
import { connect } from 'react-redux';
import './Home.css';
import logo_img from '../img/amosova_logo.jpg'
import bg_img from '../img/home_bg.jpg'
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookSquare, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';


const Home = props => (
    <div className='home-container'>
        <div className='video-container' style={{ backgroundImage: 'url(' + bg_img +')'}}>
            {/*             <video className="video_main" autoPlay='true'
             loop='true' 
             muted='true'
             playsInline='true' 
             preload='metadata' 
             src="/video/home_720p.mp4" type='video/mp4'>                                
            </video> */}
        </div>
    </div>
);

export default connect()(Home);



// WEBPACK FOOTER //
// ./src/components/Home.js